<template>
    <div>
		<el-table stripe border v-loading="loading" :data="dataList" >
			<el-table-column :label="translate('ROLE.ROLE_ID')" prop="roleId"  :show-overflow-tooltip="true"/>
			<el-table-column :label="translate('ROLE.NAME')" prop="name"  :show-overflow-tooltip="true"/>
			<el-table-column :label="translate('COMMON.STATUS')" align="center"  :show-overflow-tooltip="true">
				<template slot-scope="scope">
					<el-switch v-model="scope.row.state" active-value="ENABLE" inactive-value="DISABLE" @change="handleStatusChange(scope.row)"/>
				</template>
			</el-table-column>
			<el-table-column :label="translate('COMMON.SORT')" prop="sort" width="100" :show-overflow-tooltip="true"/>
			<el-table-column :label="translate('COMMON.CREATE_TIME')" align="center" prop="createTime"  :show-overflow-tooltip="true"/>
			<el-table-column :label="translate('COMMON.UPDATE_TIME')" align="center" prop="updateTime" :show-overflow-tooltip="true"/>
			<el-table-column :label="translate('COMMON.OPERATION')" align="center" class-name="small-padding fixed-width" width="210" fixed="right">
				<template slot-scope="scope">
					<el-button size="mini" type="text" @click="handleToRoleMenu(scope.row)" v-permission="'SYS_ROLE_UPDATE'">{{translate("MODULE.MENU")}}</el-button>
					<el-button size="mini" type="text" @click="handleUpdate(scope.row)" v-permission="'SYS_ROLE_UPDATE'">{{translate('OPERATION.UPDATE')}}</el-button>
					<el-button size="mini" type="text" @click="handleDelete(scope.row)" v-permission="'SYS_ROLE_DELETE'">{{translate('OPERATION.DELETE')}}</el-button>
				</template>
			</el-table-column>
		</el-table>

		<Pagination v-show="total > 0" :total="total" :page.sync="pageNo" :limit.sync="pageSize" @pagination="getList"/>

		<CustomForm :dicts="dicts"
					:on-fresh="showCustomForm"
					:isAdd="isAdd"
					:selectRow="selectRow"
					@on-close="() => showCustomForm = false" ></CustomForm>
	</div>
</template>

<script>
	import {UserApi} from '@/api';
	import CustomForm from "./CustomForm";
	export default {
		name: "ToolBar",
		components: {CustomForm},
		props: {
			dicts: {
				type: Object,
				default: {}
			},
			queryParams: {
				type: Object,
				default: {},
			},
		},
		data() {
			return {
				pageNo: 1,
				pageSize: 10,
				loading: false,
				total: 0,
				dataList: [],
				selectRow: {},
				showCustomForm: false,
				isAdd: false
			}
		},
		mounted() {
		},
		watch: {
			queryParams: function () {
				this.pageNo = 1;
				this.getList();
			},
		},
		methods: {
			async getList() {
				this.loading = true;
				let result = await UserApi.role.list(this.pageNo, this.pageSize, this.queryParams);
				this.loading = false;
				this.total = result.count || 0;
				this.dataList = result.data || [];
			},
			handleToRoleMenu(row){
				this.$router.push(`/userAuthority/roleMenuManage/${row.roleId}`)
			},
			handleStatusChange(row) {
				let text = row.status === "DISABLE" ? "FROM.DISABLE" : "FROM.ENABLE";
				this.$confirm(this.translate('FROM.CONFIRM_OPERATION', {module: 'MODULE.ROLE', operation: text}), this.translate('FROM.WARNING'), {
					confirmButtonText: this.translate('FROM.SUBMIT'),
					cancelButtonText: this.translate('FROM.CANCEL'),
					type: "warning"
				}).then(async () => {
					let result = await UserApi.role.edit(row.roleId, {
						state: row.state
					});
					if (result.success) {
						this.getList();
					}
				}).catch(() => this.getList());
			},
			async handleUpdate(row) {
				this.showCustomForm = true;
				this.selectRow = row;
				this.isAdd = false;
			},
			handleDelete(row){
				this.$confirm(this.translate('FROM.CONFIRM_DELETE', {module: 'MODULE.ROLE', id: row.roleId}), this.translate('FROM.WARNING'), {
					confirmButtonText: this.translate('FROM.SUBMIT'),
					cancelButtonText: this.translate('FROM.CANCEL'),
					type: "warning"
				}).then(async () => {
					let result = await UserApi.role.remove(row.roleId);
					if (result.success) {
						this.Message.success(this.translate('FROM.DELETE_SUCCESS'));
						this.getList();
					}
				});
			},
		}
	};
</script>

<style scoped>

</style>
